import $ from 'jquery';

function hideModalAndOverlay(overlay) {
  const modal = document.querySelector('.paid-modal.active');

  modal?.classList.remove('active');
  overlay.fadeOut();
}

function initModal() {
  const overlay = $('#overlay')

  overlay?.on('click', function () {
    hideModalAndOverlay(overlay);
  });

  const dismissModalButtons = document.querySelectorAll('.paid-modal .dismiss-modal');

  dismissModalButtons?.forEach(function (button) {
    button.addEventListener('click', function () {
      hideModalAndOverlay(overlay);
    });
  });
}

export { initModal };
